import { LoadingStatus } from 'src/enums/webview-loading-status';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoaderState } from './loaderState.model';

const initialState: LoaderState = {
    loadingStatus: LoadingStatus.None,
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        setLoadingState: (state, action: PayloadAction<LoadingStatus>) => {
            return { ...state, loadingStatus: action.payload };
        },
    },
});

export const { setLoadingState } = loadingSlice.actions;

export default loadingSlice.reducer;
